import React, { useMemo } from 'react';
import classNames from 'classnames';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage';
import uuidv4 from "../../utils/uuidv4";
/**
 * Bronson TileSelectGroup component.
 * @see https://bronson.vwfs.io/default/components/detail/bronson-tile-select-group.html
 * @constructor
 */
export function TileSelectGroup({ children, className, errorMessage, groupType = 'checkbox', id, layoutItemClassName, required, testId, title, ...otherProps }) {
    /**
     * Generate unique id, if prop `id` is not provided to improve accessibility.
     */
    const tileSelectGroupId = useMemo(() => id ?? uuidv4('tile-select-group-'), [id]);
    const renderChildren = () => {
        return React.Children.map(children, (child) => {
            if (!child) {
                return null;
            }
            const layoutItemClassNameList = classNames('o-layout__item', layoutItemClassName).trim();
            return React.createElement("div", { className: layoutItemClassNameList }, child);
        });
    };
    const renderIfError = () => {
        if (!errorMessage)
            return null;
        return typeof errorMessage === 'string' ? React.createElement(ErrorMessage, { id: tileSelectGroupId }, errorMessage) : errorMessage;
    };
    const renderIfTitleText = () => {
        if (title.text) {
            return (React.createElement("legend", { className: "c-form-field__label" }, title.text));
        }
        return null;
    };
    const classNameList = classNames('o-layout', 'o-layout--equal-height', className).trim();
    return (React.createElement("fieldset", { className: "c-form-field  c-form-field--static", ...otherProps, "data-testid": testId, "aria-describedby": errorMessage ? `error-${tileSelectGroupId}` : undefined, "aria-invalid": !!errorMessage || undefined, "aria-labelledby": title.referenceId, "aria-required": required, role: groupType === "radio" ? 'radiogroup' : undefined },
        renderIfTitleText(),
        React.createElement("div", { className: classNameList },
            " ",
            renderChildren(),
            " "),
        renderIfError()));
}
